<template>
  <v-card>
    <v-toolbar
      dark
      dense
      flat
    >
      <v-toolbar-title>
        <v-icon>mdi-account</v-icon>
        {{ customer.name }}
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-container>
        <v-row class="wrap">
          <v-col
            cols="12"
            md="4"
            v-if="customer.id"
          >
            <h3 class="body-2 grey--text">תעודת זהות</h3>
            <span class="title black--text">{{ customer.id }}</span>
          </v-col>
          <v-col
            cols="12"
            md="4"
            v-if="customer.phone"
          >
            <h3 class="body-2 grey--text">טלפון</h3>
            <a :href="`tel:${customer.phone}`">
              <span class="title">{{ customer.phone }}</span></a>
          </v-col>
          <v-col
            cols="12"
            md="4"
            v-if="customer.email"
          >
            <h3 class="body-2 grey--text">אי-מייל</h3>
            <a :href="`mailto:${customer.email}`">
              <span class="title">{{ customer.email }}</span></a>
          </v-col>
          <v-col
            cols="12"
            md="4"
            v-if="customer.created"
          >
            <h3 class="body-2 grey--text">תאריך יצירה</h3>
            <span class="title black--text">{{ heDate(customer.created, true) }}</span>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { format } from "date-fns";
import Mixins from '@/mixins/mixins';
// import shouldShow from "@/utils/shouldShow";

export default {
  data() {
    return {
      removing: []
    };
  },
  computed: {},
  props: ["customer"],
  watch: {},
  mounted() {},
  methods: {
    format
  },
  components: {},
  mixins: [Mixins]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>